"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidDate = exports.parseDate = exports.debounce = exports.toJSON = exports.serializable = exports.autobind = exports.UniqueBatchQueue = exports.BatchQueue = exports.merge = void 0;
var tslib_1 = require("tslib");
var merge = require("./merge");
exports.merge = merge;
var autobind_1 = require("./autobind");
Object.defineProperty(exports, "autobind", {
  enumerable: true,
  get: function () {
    return autobind_1.autobind;
  }
});
var BernieL10n = require("bernie-l10n");
tslib_1.__exportStar(require("./timeout-promise"), exports);
tslib_1.__exportStar(require("./retry"), exports);
var batch_queue_1 = require("./batch-queue");
Object.defineProperty(exports, "BatchQueue", {
  enumerable: true,
  get: function () {
    return batch_queue_1.BatchQueue;
  }
});
var unique_batch_queue_1 = require("./unique-batch-queue");
Object.defineProperty(exports, "UniqueBatchQueue", {
  enumerable: true,
  get: function () {
    return unique_batch_queue_1.UniqueBatchQueue;
  }
});
var not_serialize_1 = require("./not-serialize");
Object.defineProperty(exports, "serializable", {
  enumerable: true,
  get: function () {
    return not_serialize_1.serializable;
  }
});
Object.defineProperty(exports, "toJSON", {
  enumerable: true,
  get: function () {
    return not_serialize_1.toJSON;
  }
});
var debounce_1 = require("./debounce");
Object.defineProperty(exports, "debounce", {
  enumerable: true,
  get: function () {
    return debounce_1.debounce;
  }
});
/***/
/*** previously from: ./parse-data ***/
/************************************/
/**
 * @deprecated
 * @see bernie-l10n for replacement
 */
exports.parseDate = BernieL10n.parseDate;
/**
 * @deprecated
 * @see bernie-l10n for replacement
 */
exports.isValidDate = BernieL10n.isValidDate;